$(document).ready(function(){
    if (!$.cookie("bw_tax_notice_accepted")) {
        $('#taxPageZuruck').removeClass('d-none');
        $('#taxElseZuruck').remove(); 
        $('#germanTaxTwo').modal('toggle')
    }
})

$('#taxPageZuruck').click(function(){
    if(history.length < 1) {
        window.location="/"
    } else {
        window.history.back()
    }
})

$('#goToTaxTwo').click(function(){
    window.location="/de/german-tax/";
    $.cookie("bw_tax_notice_accepted", "checked" , { path: '/', secure: true })
})

$('#taxCheckTwo').click(function(){
    if(this.checked == true ) {
        $('#goToTaxTwo').removeAttr('disabled')
    } else {
        $('#goToTaxTwo').attr('disabled', true)
    } 
})
 